// @see https://attacomsian.com/blog/javascript-base64-encode-decode
// @see https://github.com/dankogai/js-base64#readme
import {Base64} from 'js-base64';
import {isString} from 'lodash';

export default {
  encode(str, urlSafe = false) {
    if (!isString(str)) {
      str = JSON.stringify(str);
    }
    return Base64.encode(str, urlSafe)
  },
  decode(str) {
    return Base64.decode(str);
  },
  /**
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
   * @param str
   * @returns {string}
   */
  b64EncodeUnicode(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
  },
}
